<template>
  <div class="column" ref="form">
    <section>
      <b-field label="Cosa hai visto?">
        <b-input
          ref="input1"
          v-model="imdbName"
          required
          validation-message="Scrivi qualcosa!"
          @keyup.native.enter="doOkImdb"
        ></b-input>
      </b-field>
    </section>
    <section>
      <div class="buttons">
        <b-button @click="doOkImdb" type="is-primary">Vai</b-button>
      </div>
    </section>
    <section>
      <div style="cursor: pointer">
        <b-table
          :data="imdbData"
          :columns="imdbColumns"
          :striped="true"
          :paginated="true"
          :per-page="10"
          :total="total"
          :current-page.sync="page"
          :pagination-simple="false"
          :selected.sync="selected"
          @click="imdbClicked"
        />
      </div>
    </section>
  </div>
</template>

<script>
import api from "../api/api.js";
import timdb from "../api/timdb.js";
import helpers from "../helpers.js";

let emptyVal = { id: 0, Dicks: 0 };

export default {
  name: "AddSeries",
  methods: {
    isoDate(date) {
      return helpers.buildIsoDate(date);
    },
    doOkImdb() {
      const loading = this.$buefy.loading.open();
      api.vision.checkImdb(this.imdbName).then((data) => {
        data = data.data;
        let imdbData = timdb.parseImdbResponse(data, false);
        if (imdbData.length == 0 && data.d.length > 0) {
          helpers.error(
            "E' probabile che imdb abbia interpretato come nome di attore quello che cercavi. Aggiungi anche l'anno nella ricerca"
          );
        } else {
          this.imdbData = imdbData;
        }
        loading.close();
      })
      .catch(() => {
        helpers.error("Urca, qualcosa è andato male nella ricerca");
          loading.close();
      });
    },
    imdbClicked(row) {
      const loading = this.$buefy.loading.open();
      api.series.getTmdb(row.id)
        .then((data) => {
          loading.close();
          let imdb = {Series:data.data}
          this.$emit("OkSearchImdb", imdb);
        })
        .catch(() => {
          loading.close();
        });
    },
  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      vShow: {},
      rowData: [],
      imdbData: [],
      selected: null,
      lovs: {},
      insertQueue: "Insert",
      selectedTab: 0,
      imdbName: "",
      page: 1,
      perPage: 10,
      total: 0,
      filter: {},
      imdbColumns: [
        {
          field: "url",
          label: "",
        },
        {
          field: "title",
          label: "Titolo",
        },
        {
          field: "years",
          label: "Anni",
        },
        {
          field: "starring",
          label: "Con",
        },
      ],
    };
  },
  mounted() {},
};
</script>

<style>
</style>
